module.exports = __webpack_public_path__ + "img/nevonex.757146c2.png";